import React from 'react'
import { Form } from 'antd';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { api } from '../../../../../api/api';
import { useFormStatus } from '../../../../../utils/hooks/useFormStatus';
import FormStatus from '../../../../../components/form/FormStatus/FormStatus';
import { SkillFormFields } from '../../../../../types/formFieldTypes';
import { getAntField } from '../../../../../utils/form';
import { clearSkillErrors, initialSkillFields, skillValidate } from '../../formData/SkillFormData';
import { errorNotification, invalidateQueries } from '../../../../../utils/rest';
import { SwitchSkillItems } from '../../../../../types/propsTypes';
import SkillFormInputs from '../SkillFormInputs/SkillFormInputs';
import { queryKeysSkill } from '../../../../../static/data/queryKeys';

type SkillAddFormProps = {
    switchData: SwitchSkillItems
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>
}

const SkillAddForm: React.FC<React.PropsWithChildren<SkillAddFormProps>> = React.memo((props) => {
    const {
        switchData
    } = props
    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        setFieldValue, handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<SkillFormFields>({
        initialValues: initialSkillFields,
        validateOnChange: false,
        onSubmit: (values) => {
            mutate(values)
        },
        validate: skillValidate
    })

    const antField = getAntField<SkillFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        api.skills.create,
        {
            mutationKey: 'skill-add',
            onSuccess() {
                invalidateQueries(queryKeysSkill[1])
                formStatus.setMessage('Объект успешно добавлен')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError: (err: Error) => errorNotification(err, 'Ошибка создания', formStatus),
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialSkillFields)
        setErrors(clearSkillErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setTimeout(formStatus.reset, 300)
    }

    return (
        <Form fields={[
            antField('course_id', {withFalsy: true}),
            antField('name'),
        ]}>
            <SkillFormInputs
                switchData={switchData}
                values={values}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                clearForm={clearForm}
                submitForm={submitForm}
            />
            <FormStatus formStatus={formStatus} />
        </Form>
    )
})

export default SkillAddForm